module.exports = __webpack_public_path__ + "media/images/hyper/bg-pattern-light-73fb1698735f2e4bc701f1f23527c501.svg";